import { getCurrentBrand } from "../configs/brandConfigs";

const activeBrand = getCurrentBrand();

const assets = {
    images: {
        logo: activeBrand?.logo,
        logo_white: activeBrand?.logo_white,
        logo2: require('./images/nommi_logo.png'),
        banner1: require('./images/NommiBanner.png'),
        banner2: require('./images/Banner2.jpg'),
        mobileBanner1: require('./images/MobileBanner1.jpg'),
        mobileBanner2: require('./images/MobileBanner2.jpg'),

        partnersLogo1: require('./images/FairPrice.png'),
        partnersLogo2: require('./images/Cheers.png'),
        partnersLogo3: require('./images/7eleven.png'),
        partnersLogo4: require('./images/Cold Storage.png'),
        partnersLogo5: require('./images/Giant.png'),
        partnersLogo6: require('./images/Shengsiong.png'),
        partnersLogo7: require('./images/Shellselect.png'),


        badge1: require('./images/badge.png'),
        featureLogo1: require('./images/featureLogo1.png'),
        featureLogo2: require('./images/featureLogo2.png'),
        smartFridge: require('./images/SmartFridge.png'),
        excited: require('./images/Excited.png'),
        kids: require('./images/Kids.png'),
        stickers1: require('./images/Nommi stickers (edm)-01.png'),
        stickers2: require('./images/Nommi stickers (edm)-02.png'),
        stickers3: require('./images/Nommi stickers (edm)-03.png'),
        stickers4: require('./images/Nommi stickers (edm)-04.png'),
        stickers5: require('./images/Nommi stickers (edm)-05.png'),
        stickers6: require('./images/Nommi stickers (edm)-06.png'),
        step1: require('./images/step 1.jpg'),
        step2: require('./images/step 2.jpg'),
        step3: require('./images/step 3.png'),
        introducing: require('./images/Introducing.gif'),
        step1Gif: require('./images/Step1.gif'),
        step2Gif: require('./images/Step2.gif'),
        step3Gif: require('./images/Step3.gif'),
        step4Gif: require('./images/Step4.gif'),
        Explorer: require('./images/Explorer.png'),
        greenTick: require('./images/green_tick.png'),
        wallet: require('./images/wallet.png'),
        creditCard: require('./images/credit_card.png'),
        payNowLogo: require('./images/PayNow-Logo.png'),
        payNowBtn: require('./images/PayNow.png'),
        popupBorder: require('./images/popup_border.png'),
        halalLogo: require('./images/halal-logo.png'),
        ViewMenu: require('./images/ViewMenu.png'),
        TikTok: require('./images/TikTok.png'),
        paymentButton: require('./images/payment_button.png'),
        AppStore: require('./images/AppStore.png'),
        GooglePlayStore: require('./images/GooglePlayStore.png'),
    }
};

export default assets;